import { render, staticRenderFns } from "./tencet_sms_stutas.vue?vue&type=template&id=4f805747&"
import script from "./tencet_sms_stutas.vue?vue&type=script&lang=js&"
export * from "./tencet_sms_stutas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports